<template>
  <div class="registro-exitoso-wrapper">
    <v-app-bar app fixed color="white" elevation="2" height="70">
      <v-container
        class="d-flex align-center justify-space-between main-container"
      >
        <a href="#inicio" class="logo text-decoration-none d-flex align-center">
          <v-img
            src="../../public/logo.webp"
            max-height="64"
            max-width="150"
            contain
          ></v-img>
        </a>

        <span class="primary--text text-h4 font-weight-bold d-none d-sm-block"
          >Tokia Play</span
        >
      </v-container>
    </v-app-bar>

    <div class="content-wrapper">
      <v-container class="fill-height">
        <v-row align="center" justify="center">
          <v-col cols="12" lg="8" xl="7">
            <v-card
              color="#FFFFFF"
              class="main-card elevation-8"
              style="border-radius: 16px;"
            >
              <v-card-text class="pa-8 pa-md-10">
                <div class="text-center mb-6">
                  <v-icon size="100" color="success" class="mb-4 success-icon">
                    mdi-check-circle
                  </v-icon>
                </div>

                <div class="container">
                  <div class="justify-content-center">
                    <h3
                      class="text-center"
                      style="color:#1E0E62; font-size: 40px;line-height: 1.2; margin-bottom: 2rem;"
                    >
                      ¡Complejo registrado exitosamente!
                    </h3>

                    <div
                      class="success-content"
                      style="margin-bottom:3rem; font-size: 18px; line-height: 1.8;"
                    >
                      <v-alert
                        color="#0B214B"
                        dark
                        class="mb-6"
                        style="border-radius: 12px;"
                      >
                        <h4 class="mb-3">
                          Estimado <strong>{{ nombre }}</strong
                          >, su complejo se ha registrado con éxito
                        </h4>
                        <p class="mb-4">
                          Le damos una cordial bienvenida a
                          <strong>Tokia Play</strong>
                        </p>
                      </v-alert>

                      <v-card
                        class="pa-6 mb-6 credentials-card"
                        outlined
                        style="border: 2px solid #0B214B; border-radius: 12px;"
                      >
                        <h4 class="mb-4" style="color: #1E0E62;">
                          <v-icon color="#0B214B" class="mr-2"
                            >mdi-email-check</v-icon
                          >
                          Se le acaba de enviar un correo electrónico con sus
                          datos de acceso
                        </h4>

                        <v-divider class="mb-4"></v-divider>

                        <v-row class="credentials-info">
                          <v-col cols="12" md="6">
                            <div class="credential-item">
                              <v-icon color="#0B214B" class="mr-2"
                                >mdi-account</v-icon
                              >
                              <div>
                                <div class="credential-label">Usuario</div>
                                <div class="credential-value">
                                  {{ usuario }}
                                </div>
                              </div>
                            </div>
                          </v-col>
                          <v-col cols="12" md="6">
                            <div class="credential-item">
                              <v-icon color="#0B214B" class="mr-2"
                                >mdi-lock</v-icon
                              >
                              <div>
                                <div class="credential-label">Contraseña</div>
                                <div class="credential-value">{{ clave }}</div>
                              </div>
                            </div>
                          </v-col>
                        </v-row>
                      </v-card>

                      <v-alert
                        color="#F7941D"
                        dark
                        icon="mdi-information"
                        class="mb-4"
                        style="border-radius: 12px;"
                      >
                        <strong>Importante:</strong> Guarde estas credenciales
                        en un lugar seguro. Podrá cambiar su contraseña una vez
                        que ingrese al sistema.
                      </v-alert>
                    </div>

                    <v-card-actions
                      style="padding: 0; display: flex; justify-content: space-between; align-items: center; flex-wrap: wrap; gap: 1.5rem; margin-top: 2rem;"
                    >
                      <v-btn
                        color="#F7941D"
                        x-large
                        href="https://cloud.tokiaplay.com"
                        style="border-radius: 10px; color: white; text-transform: none; box-shadow: 0 4px 8px rgba(247, 148, 29, 0.3);"
                        class="px-8"
                      >
                        <v-icon left>mdi-login</v-icon>
                        Iniciar Sesión
                      </v-btn>

                      <a
                        class="back-link"
                        @click="salir"
                        style="font-size: 14px; color: rgba(21, 20, 57, 0.4); cursor: pointer; text-decoration: none; transition: all 0.3s ease;"
                      >
                        <v-icon small color="rgba(21, 20, 57, 0.4)" class="mr-1"
                          >mdi-arrow-left</v-icon
                        >
                        Volver a Tokia Play
                      </a>
                    </v-card-actions>
                  </div>
                </div>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </div>
  </div>
</template>

<script>
import router from "../router/index.js";

export default {
  data: (vm) => ({
    usuario: "",
    nombre: "",
    clave: "",
  }),
  methods: {
    salir() {
      router.push("/");
    },
  },
  mounted() {
    window.scrollTo({ top: 0, behavior: "smooth" });
    this.usuario = this.$store.state.usuario;
    this.nombre = this.$store.state.nombre;
    this.clave = this.$store.state.clave;
  },
};
</script>

<style scoped>
.registro-exitoso-wrapper {
  min-height: 100vh;
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
}

.content-wrapper {
  min-height: 100vh;
  display: flex;
  align-items: center;
  padding-top: 70px;
  padding-bottom: 2rem;
}

.main-container {
  margin-left: 0.5rem;
  margin-right: 0.5rem;
  max-width: 100%;
}

.main-card {
  width: 100%;
  max-width: 100%;
}

/* Success Icon Animation */
@keyframes checkmark {
  0% {
    transform: scale(0) rotate(0deg);
    opacity: 0;
  }
  50% {
    transform: scale(1.2) rotate(360deg);
  }
  100% {
    transform: scale(1) rotate(360deg);
    opacity: 1;
  }
}

.success-icon {
  animation: checkmark 0.8s ease-out;
}

/* Credentials Card */
.credentials-card {
  background: linear-gradient(
    135deg,
    rgba(11, 33, 75, 0.02) 0%,
    rgba(247, 148, 29, 0.02) 100%
  );
  transition: all 0.3s ease;
}

.credentials-card:hover {
  box-shadow: 0 4px 12px rgba(11, 33, 75, 0.1) !important;
  transform: translateY(-2px);
}

.credentials-info {
  margin-top: 1rem;
}

.credential-item {
  display: flex;
  align-items: flex-start;
  padding: 1rem;
  background: white;
  border-radius: 8px;
  border: 1px solid #e0e0e0;
  transition: all 0.3s ease;
}

.credential-item:hover {
  border-color: #0b214b;
  box-shadow: 0 2px 8px rgba(11, 33, 75, 0.1);
}

.credential-label {
  font-size: 12px;
  color: rgba(21, 20, 57, 0.6);
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 4px;
}

.credential-value {
  font-size: 18px;
  font-weight: 700;
  color: #1e0e62;
  font-family: "Courier New", monospace;
}

.success-content {
  animation: fadeIn 0.6s ease-out;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.back-link:hover {
  color: #0b214b !important;
  padding-left: 5px;
}

/* Para pantallas pequeñas */
@media (max-width: 959px) {
  .content-wrapper {
    padding-top: 90px;
    padding-bottom: 1rem;
  }

  h3 {
    font-size: 32px !important;
  }
}

@media (max-width: 599px) {
  .content-wrapper {
    padding-top: 100px;
  }

  .primary--text.text-h4 {
    font-size: 1.5rem !important;
  }

  h3 {
    font-size: 28px !important;
  }

  .success-content {
    font-size: 16px !important;
  }

  .credential-value {
    font-size: 16px;
  }
}
</style>
